const { createSelector } = require("reselect");

const selectLogin = (state) => state["marketplace.login"].login;

const login = () => createSelector([selectLogin], (prf) => prf.data);

const loginError = () => createSelector([selectLogin], (prf) => prf.error);

const loginLoading = () => createSelector([selectLogin], (prf) => prf.loading);

module.exports = {
  login,
  loginError,
  loginLoading,
};
